// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__3VGYo","align-vertically":"style_align-vertically__3Kbz4"};